import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import ScenariiManager from './manager/manager-container'
import * as routes from '../../util/routes'

export default class ScenariiComponent extends React.Component {
	render() {
		return <Switch>
			<Route exact path={routes.PROJECTION_SCENARII_PATTERN} render={props =>
				<ScenariiManager {...props} />
			}/>
		</Switch>
	}
}

export interface RouteParams {
	slug: string;
	scenarioId: string;
}



// WEBPACK FOOTER //
// ./src/component/scenarii/index.tsx